export default {
    /** 出现位置 */
    position: "middle",
    /** 显示时长 */
    duration: 3000,
    /** 背景色 */
    background: "rgba(0,0,0,.6)",
    /** 点击事件穿透 */
    eventPenetrate: true,
    /** 是否在页面切换时自动关闭 */
    closeOnPopstate: false
}
